import React from 'react';
import ViewRef from '@/util/ViewRef';
import { ColumnFilter } from '@/components/modals/ModalAddWidget/subcomponents/ColumnFilter';
import { useSelector } from 'react-redux';
import { getDashboardFilters } from '@/store-selectors';
import { ConfigurationSectionTitle } from '../ConfigurationSectionTitle';
import { useFilterConfiguration } from './useFilterConfiguration';

export const FiltersConfiguration: React.FC<{ view: Maybe<ViewRef> }> = ({
  view,
}) => {
  const noDashboardFilters = useSelector(getDashboardFilters).length === 0;
  const filterData = useFilterConfiguration(view);

  if (noDashboardFilters || !filterData) return null;

  return (
    <>
      <ConfigurationSectionTitle isOptional>
        Configure dashboard filters
      </ConfigurationSectionTitle>
      <ColumnFilter
        selectedSavedQuery={view}
        queryColumns={filterData.queryColumns}
        aliases={filterData.aliases}
      />
    </>
  );
};
